import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';

const useDeleteCoreEnum = (enumId: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutationApi<void, void>({
    endpoint: `core/core-enums/${enumId}`,
    method: 'DELETE',
    successMessage: 'Enum deleted successfully',
    errorMessage: 'Failed to delete enum',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['core/core-enums'] });
        onSuccess?.();
      },
    },
  });
};

export default useDeleteCoreEnum;
